import * as React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { format } from 'date-fns';
import { parseDateString } from '../utils/Utils';

const CustomPicker = ({ type, data, customStyles, handleDateChange, name, disabled }) => {
  let picker;
  const stringValue = data[name];
  const dateValue = parseDateString(stringValue, type);

  if (type === 'monthly') {
    picker = (
      <KeyboardDatePicker
        fullWidth
        placeholder="MMMM"
        value={dateValue}
        InputProps={{
          disableUnderline: true,
          classes: {
            input: customStyles,
          },
          disabled,
        }}
        onChange={(date) => {
          if (!Number.isNaN(date)) {
            try {
              handleDateChange(name, format(date, 'MMMM'));
            } catch (error) {
              console.log('error', error);
            }
          }
        }}
        format="MMMM"
        views={['month']}
      />
    );
  } else if (type === 'yearly') {
    picker = (
      <KeyboardDatePicker
        fullWidth
        placeholder="YYYY"
        value={dateValue}
        InputProps={{
          disableUnderline: true,
          classes: {
            input: customStyles,
          },
          disabled,
        }}
        onChange={(date) => {
          if (!Number.isNaN(date)) {
            try {
              handleDateChange(name, format(date, 'yyyy'));
            } catch (error) {
              console.log('error', error);
            }
          }
        }}
        format="yyyy"
        views={['year']}
      />
    );
  } else {
    picker = (
      <KeyboardDatePicker
        fullWidth
        placeholder="YYYY-MM-DD"
        name={name}
        value={dateValue}
        InputProps={{
          disableUnderline: true,
          classes: {
            input: customStyles,
          },
          disabled,
        }}
        onChange={(date) => {
          if (!Number.isNaN(date)) {
            try {
              if (date) {
                handleDateChange(name, format(date, 'yyyy-MM-dd'));
              } else {
                handleDateChange(name, '');
              }
            } catch (error) {
              console.log('error', error);
            }
          }
        }}
        format="yyyy-MM-dd"
      />
    );
  }

  return <MuiPickersUtilsProvider utils={DateFnsUtils}>{picker}</MuiPickersUtilsProvider>;
};

export default React.memo(CustomPicker);
